module.exports = "/fonts/vendor/@flaticon/flaticon-uicons/css/uicons-brands-XJPKRNBN.woff2?033917e9fd41cfa9727ccb78c8e8da90";